module.exports = __webpack_public_path__ + "img/m107.5691cedd.png";